import { CamelracingBanner, RacingBanner } from "../Banner";

export function Header() {
  return (
    <div className="flex items-center justify-center">
      <div className="h-12 md:h-16 lg:h-[102px]">
        <RacingBanner />
      </div>
    </div>
  );
}
